import React from "react";
import Header from "../components/portfolio/Header";
import WorkGrid from "../components/portfolio/WorkGrid";
import Footer from "../components/portfolio/Footer";
import { PavementSides } from "../components/portfolio/Panot";
import useBackLink from "../hooks/useBackLink";

// Every piece in two groups: the case studies again with the apps and
// plugins, then the interface work and the motion pieces. The homepage argues
// the thesis; this page is the index behind it, and opens the same way: a
// centred title between two fields of pavement.

const HOME = { to: "/", label: "Home" };

function Work() {
  const back = useBackLink(HOME);
  return (
    <div className="pf-home min-h-screen w-full">
      <PavementSides id="pf-panot-work" className="pf-pavement--work" />
      <Header back={back} />
      <main id="main" tabIndex={-1}>
        <section className="pf-shell pf-work-intro pf-work-intro--centred">
          <h1 className="pf-work-intro__title">Work</h1>
          <p className="pf-work-intro__lead">
            Case studies, apps, plugins, interfaces and motion.
          </p>
        </section>
        <WorkGrid />
      </main>
      <Footer />
    </div>
  );
}

export default Work;
